var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 layout"},[_c('login-header'),_c('main',[_c('div',{staticClass:"container login-container"},[_vm._t("default")],2)]),_c('login-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }